import script from "./AppSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSettings.vue?vue&type=script&setup=true&lang=js"

import "./AppSettings.vue?vue&type=style&index=0&id=bf39f3c2&lang=css"

const __exports__ = script;

export default __exports__